// @flow
// @jsx h
import { h, Component } from "preact";
import { Text, MarkupText } from "preact-i18n";
//liste ds pays
import { withStyles, ThemeConfig } from "elc-theme";

import styles from "./style.scss";

// Utility functions
import { toLocalePrice, COUNTRIES } from "elc-commons";

type AddMeetchProps = {
  isAssuranceAnnulation: boolean,
  toggleAssuranceAccepted: Function,
  locale: string,
  currency: Currency,
  handleInputChange: Function,
  dataAssurance: object | null,
  currentOrder: Order,
  getAssurance: Function,
  initAssuranceMeetch: object | null,
};

type AddMeetchState = {
  assurance: object | null,
  dataAssurance: object | null,
};

class AddMeetch extends Component<
  AddMeetchProps,
  AddMeetchState,
> {
  constructor(props) {
    super(props);

    this.state = {
      assurance: null,
      dataAssurance: {
        adresse: "",
        cp: "",
        ville: "",
        pays: "fr",
      },
      showAssuranceAnnulation: false,
    };

    if (props.initAssuranceMeetch != null) {
      this.setState({ assurance: props.initAssuranceMeetch });
    }

    if (props.dataAssurance != null) {
      this.setState({ dataAssurance: props.dataAssurance });
    }
  }

  handleChange = (e) => {
    const form = e.currentTarget.form || e.currentTarget.closest("form");
    const formData = new FormData(form);

    const newState = {};
    for (let [key, value] of formData.entries()) {
      newState[key] = value;
    }
    this.setState({ dataAssurance: newState });
    this.props.handleInputChange(newState);
  };

  handleAcceptAssurance = ({ target }) => {
    this.props.toggleAssuranceAccepted(target.checked);
    if (!target.checked) {
      this.props.handleInputChange({
        adresse: "",
        cp: "",
        ville: "",
        pays: "fr",
      });
    } else {
      this.props.handleInputChange(this.state.dataAssurance);
    }
  };

  onClickShowAssuranceAnnulation = () => {
    this.setState({
      showAssuranceAnnulation: !this.state.showAssuranceAnnulation,
    });
  };

  onClickCloseAssuranceAnnulation = () => {
    this.setState({ showAssuranceAnnulation: false });
  };

  componentDidMount() {
    // console.log("componentDidMount meetch", this.props);
    // console.log("componentDidMount meetch this.state", this.state);

    this.props.getAssurance();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.initAssuranceMeetch !== this.state.assurance) {
      this.setState({ assurance: nextProps.initAssuranceMeetch });
    }

    if (
      nextProps.dataAssurance !== this.state.dataAssurance &&
      nextProps.dataAssurance != null
    ) {
      this.setState({ dataAssurance: nextProps.dataAssurance }, () => {
        this.props.handleInputChange(nextProps.dataAssurance);
      });
    }
  }

  render(
    { isAssuranceAnnulation, locale, currency }: AddMeetchProps,
    { assurance, dataAssurance, showAssuranceAnnulation }: AddMeetchState,
  ) {
    const url =
      assurance?.urlConditionsAssurance?.[locale === "en" ? "uk" : locale] ||
      "#";

    const handleCilckAssurance = (e) => {
        e.preventDefault();
        this.onClickShowAssuranceAnnulation(); // ou this.onClickShowAssuranceAnnulation() si class
      };
    return (
      <ThemeConfig.Consumer>
        {(themeConfig) => {
          return (
            <div>
              {assurance?.assuranceApplicable ? (
                <div class={styles.assuranceWidgetContainer}>
                  <div
                    class={`${styles.assuranceWidget} ${
                      isAssuranceAnnulation ? styles.active : ""
                    }`}
                  >
                    {!isAssuranceAnnulation ? (
                      <div>
                        <div class={styles.titre}>
                            <MarkupText id="basket.meetch.ligneIntroPart1"
                            fields={{
                              assurancePrice: toLocalePrice(
                                assurance?.montantAssurance,
                                locale,
                                currency.isoCode),
                                class: styles.assurancePrice,
                              }}
                                >
                              <strong>Pour <span>xxx</span>, vous pouvez souscrire une assurance annulation</strong> auprès de
                            </MarkupText>
                        </div>
                        {/* <label class={styles.checkboxContainer}>
                      <input
                        type="checkbox"
                        checked={isAssuranceAnnulation}
                        onChange={this.handleAcceptAssurance}
                      />
                      <span class={styles.customCheckbox}></span>
                      <span class={styles.checkboxLabel}>
                        J'accepte les conditions
                      </span>
                    </label> */}
                        <ul class={styles.assuranceBenefits}>
                          <li>
                            <span>
                              <b>
                                <Text id="basket.meetch.rassurance.ligne1">
                                  Sans franchise
                                </Text>
                              </b>
                            </span>
                          </li>
                          <li>
                            <span>
                              <b>
                                <Text id="basket.meetch.rassurance.ligne2">
                                  + de 30 clauses d'annulation
                                </Text>
                              </b>
                            </span>
                          </li>
                          <li>
                            <span>
                              <MarkupText id="basket.meetch.rassurance.ligne3">
                                Assurez votre activité pour être remboursé <b>jusqu'à la dernière minute</b>
                              </MarkupText>                              
                            </span>
                          </li>
                        </ul>

                        <p class={styles.infoNotice}>
                          <Text id="basket.meetch.noticePart1">
                            J'ai bien pris connaissance de
                          </Text>{" "}
                          <a
                            class={styles.LienDetailAssurance}
                            href="#"
                            onClick={(e) => {
                              e.preventDefault(); // Évite le comportement par défaut du lien
                              this.onClickShowAssuranceAnnulation();
                            }}
                          >
                            <Text id="basket.meetch.noticePart2">
                              la notice d'information et en accepte les termes
                              et conditions
                            </Text>
                          </a>
                        </p>
                      </div>
                    ) : (
                      ""
                    )}

                    <div class={styles.switchInput}>
                      <label
                        htmlFor="isAssuranceAnnulation"
                        class={styles.switch}
                      >
                        <input
                          type="checkbox"
                          id="isAssuranceAnnulation"
                          name="isAssuranceAnnulation"
                          checked={isAssuranceAnnulation}
                          onChange={this.handleAcceptAssurance}
                        />
                        <span
                          class={`${styles.slider} ${styles.round}`}
                          style={`${
                            themeConfig &&
                            themeConfig.color1 &&
                            isAssuranceAnnulation
                              ? "background-color:" + themeConfig.color1
                              : ""
                          }`}
                        />
                      </label>
                      <label
                        htmlFor="isAssuranceAnnulation"
                        class={styles.switchLabel}
                      >
                        <Text id="basket.meetch.labelSwich">
                          Je choisis l'assurance annulation
                        </Text>
                      </label>
                    </div>

                    {isAssuranceAnnulation ? (
                      <div>
                        <div className={styles.assuranceInfos}>
                          <div class={styles.bookingHeader}>
                            <div class={styles.productName}>
                              <Text id="basket.meetch.produitAssuranceLabel">
                                Assurance Annulation
                              </Text>
                              <br />
                            </div>
                            <div>
                              <span
                                class={styles.bookingTotal}
                                style={`color:${
                                  themeConfig && themeConfig.color1
                                    ? themeConfig.color1
                                    : ""
                                };`}
                              >
                                {toLocalePrice(
                                  assurance?.montantAssurance,
                                  locale,
                                  currency.isoCode,
                                )}
                              </span>
                            </div>
                          </div>
                        </div>

                        <div
                          class={styles.headerTitleMeetch}
                          style={`color:${
                            themeConfig && themeConfig.color1
                              ? themeConfig.color1
                              : ""
                          };`}
                        >
                          <h2>
                            <Text id="basket.meetch.formGroupLabel">
                              Complétez votre adresse
                            </Text>
                          </h2>
                        </div>
                        <form>
                          <div class={styles.formGroup}>
                            <label>
                              <Text id="basket.meetch.formGroup.adresse">
                                Adresse
                              </Text>
                              <span class={styles.requiredSign}>*</span>
                            </label>
                            <input
                              name="adresse"
                              id="adresse"
                              value={dataAssurance.adresse}
                              placeholder="adresse"
                              autoComplete="off"
                              onChange={this.handleChange}
                            />
                          </div>
                          <div class={styles.row}>
                            <div
                              class={`${styles.formGroup} ${styles.zipCode}`}
                            >
                              <label>
                                <Text id="basket.meetch.formGroup.cp">
                                  Code postal
                                </Text>
                                <span class={styles.requiredSign}>*</span>
                              </label>
                              <input
                                name="cp"
                                id="cp"
                                value={dataAssurance.cp}
                                placeholder="cp"
                                autoComplete="off"
                                onChange={this.handleChange}
                              />
                            </div>
                            <div class={`${styles.formGroup} ${styles.city}`}>
                              <label>
                                <Text id="basket.meetch.formGroup.ville">
                                  Ville
                                </Text>
                                <span class={styles.requiredSign}>*</span>
                              </label>
                              <input
                                name="ville"
                                id="ville"
                                value={dataAssurance.ville}
                                placeholder="ville"
                                autoComplete="off"
                                onChange={this.handleChange}
                              />
                            </div>
                          </div>

                          <div class={styles.formGroup}>
                            <label>
                              <Text id="basket.meetch.formGroup.pays">
                                Pays
                              </Text>
                              <span class={styles.requiredSign}>*</span>
                            </label>
                            <div class={styles.selectWrapper}>
                              <select
                                name="pays"
                                value={dataAssurance.pays}
                                onInput={this.handleChange}
                                class={styles.select}
                              >
                                {COUNTRIES.map((c) => (
                                  <option key={c.code} value={c.code}>
                                    {c.name[locale] || c.name["fr"]}
                                  </option>
                                ))}
                              </select>
                            </div>
                            {/* <input
                          name="pays"
                          id="pays"
                          value={this.state.pays}
                          placeholder="pays"
                          autoComplete="off"
                          onChange={this.handleChange}
                        /> */}
                          </div>
                          <em
                            class={`${styles.requiredSign} ${styles.sizeExtraSmall}`}
                          >
                            <Text id="basket.meetch.requiredLabel">
                              * Champs obligatoires
                            </Text>
                          </em>
                        </form>
                        <p class={styles.infoNotice}>
                          <Text id="basket.meetch.noticePart1">
                            J'ai bien pris connaissance de
                          </Text>{" "}
                          <a
                            class={styles.LienDetailAssurance}
                            href="#"
                            onClick={(e) => {
                              e.preventDefault(); // Évite le comportement par défaut du lien
                              this.onClickShowAssuranceAnnulation();
                            }}
                          >
                            <Text id="basket.meetch.noticePart2">
                              la notice d'information et en accepte les termes
                              et conditions
                            </Text>
                          </a>
                        </p>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  {/* <pre>{JSON.stringify(this.state, null, 2)}</pre> */}

                  {showAssuranceAnnulation && (
                    <div
                      class={`${styles.modal} ${
                        showAssuranceAnnulation ? styles.show : ""
                      }`}
                    >
                      <div
                        class={styles.overlay}
                        onClick={this.onClickCloseAssuranceAnnulation}
                      ></div>
                      <div class={`${styles.termSales}`}>
                        <header>
                          {/* <h2>
                                              <Text id="basket.termSales.title">Hide</Text>
                                            </h2> */}
                          <button
                            onClick={this.onClickCloseAssuranceAnnulation}
                          >
                            <Text id="basket.termSales.hide">CGV</Text>
                          </button>
                        </header>
                        <div class={styles.termWrapper}>
                          <iframe src={url} height="600" />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                ""
              )}
            </div>
          );
        }}
      </ThemeConfig.Consumer>
    );
  }
}

export default withStyles(AddMeetch, styles);